import { render } from "./GroupFullCard.vue?vue&type=template&id=05336436&scoped=true"
import script from "./GroupFullCard.vue?vue&type=script&lang=js"
export * from "./GroupFullCard.vue?vue&type=script&lang=js"

import "./GroupFullCard.vue?vue&type=style&index=0&id=05336436&scoped=true&lang=scss"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05336436"]])

export default __exports__